import React from 'react'

import { Divider } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, object } from 'prop-types'

import { NOOP } from 'Utils/stableDefaults'

import Suggestion from './Suggestion'

function Suggestions({ suggestions = null, onKeywordClick = NOOP }) {
  if (!suggestions) {
    return null
  }

  const {
    keywordsInCategory = [],
    keywords = [],
    items,
    searchKeyword,
  } = suggestions

  const shouldShowDivider = keywordsInCategory.length > 0 && keywords.length > 0
  const hasKeywordsInCategory = keywordsInCategory && keywordsInCategory.length > 0
  const hasKeywords = keywords && keywords.length > 0

  return (
    <div className="cgt-model-search__suggestions cgt-effect-card-border-grey-thin">
      <ul className="cgt-model-search__suggestions-list">
        {hasKeywordsInCategory
          && keywordsInCategory.map(({
            keyword,
            categoryTitle,
            categoryHref,
            thumbnailUrl,
          }) => (
            <Suggestion
              key={keyword}
              type="keywordsInCategory"
              {...{
                keyword,
                categoryTitle,
                categoryHref,
                thumbnailUrl,
              }}
            />
          ))}

        {hasKeywords
          && keywords.map(({ suggestedKeyword, thumbnailUrl }) => (
            <Suggestion
              key={suggestedKeyword}
              type="category"
              {...{
                suggestedKeyword,
                searchKeyword,
                onKeywordClick,
                thumbnailUrl,
              }}
            />
          ))}

        {items && (
          <>
            {shouldShowDivider && (
              <Divider customClass="cgt-model-search__suggestions-divider" />
            )}
            {items.map(
              ({
                itemTitle,
                itemThumbnailImage,
                itemHref,
                thumbnailUrl,
              }) => (
                <Suggestion
                  key={itemTitle}
                  type="item"
                  {...{
                    itemTitle,
                    itemThumbnailImage,
                    itemHref,
                    thumbnailUrl,
                  }}
                />
              )
            )}
          </>
        )}
      </ul>
    </div>
  )
}

Suggestions.propTypes = {
  suggestions: object,
  onKeywordClick: func,
}

export default Suggestions
